import React, { useContext, useEffect, useState } from "react";
import Header from "../Comman/Header";
import Sidebar from "../Comman/Sidebar";
import Footer from "../Comman/Footer";
import axios from "axios";
import { IFTContext } from "../../IFTContext";
import Pagination from "../Comman/Pagination";
import Copy from "../Comman/Copy";
export default function StakingsPoolTable() {
  const { formatAddress } = useContext(IFTContext);
  const [data, setdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [modal_data, setmodal_data] = useState(null);
  const [modal_msg, setmodal_msg] = useState(null);

  const getData = async () => {
    setLoading(true);
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "pool",
        submethod: "get",
        key: process.env.REACT_APP_KEY,
        page: currentPage,
        pageSize: pageSize,
      })
      .then((res) => {
        // var dedata = decryptData(res.data);
        if (res.data.error) {
          setdata([]);
          setPages(0);
          setLoading(false);
          return "";
        }
        setdata(res.data.data);
        setPages(Math.ceil(res.data.dataLength / pageSize));
        setLoading(false);
      });
  };
  const stake = async (hash) => {
    const button = document.getElementById('closemodal');

    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "insert",
        key: process.env.REACT_APP_KEY,
        hash: hash,
        page: currentPage,
        pageSize: pageSize,
      })
      .then((res) => {
        // var dedata = decryptData(res.data);
        getData()
        if (res.data.error) {
          setmodal_msg(res.data.error)
          return "";
        }
        setmodal_msg(res.data.success)
        setTimeout(() => {
          button.click(); // Simulate a click event after 2 seconds
        }, 2000);
    
      });
  };
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pages, pageSize, currentPage]);
  return (
    <>
      <div id="main-wrapper">
        <Header />
        <Sidebar />
        <div className="content-body">
          <div className="container-fluid">
            <div className="page-titles">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Dashboard</a>
                </li>
                <li className="breadcrumb-item active text-primary">
                  Staking Pool
                </li>
              </ol>
            </div>
            <div className="form-head d-flex mb-3 mb-md-4 align-items-center">
              <div className="input-group search-area d-inline-flex me-2">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search here"
                />
                <div className="input-group-append">
                  <button type="button" className="input-group-text">
                    <i className="flaticon-381-search-2" />
                  </button>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body ">
                    <div className="d-flex justify-content-between">
                      <div className="card-title text-light">All Pool Stakings</div>
                      <span
                        className="btn btn-primary btn-sm "
                        onClick={() => getData()}
                      >
                        <i
                          className="flaticon-381-repeat-1 "
                          aria-hidden="true"
                        />
                      </span>
                    </div>
                    <hr />
                    <div className="table-responsive">
                      <table
                        id="example5"
                        className="table table-striped patient-list mb-4 dataTablesCard fs-14"
                      >
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Action</th>
                            <th>Hash</th>
                            <th>User ID</th>
                            <th>Email</th>
                            <th>User ID</th>
                            <th>Ref ID</th>
                            <th>Amount</th>
                            <th>Date & Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan={8}>Data loading...</td>
                            </tr>
                          ) : (
                            ""
                          )}
                          {data.map((ele, i) => {
                            return (
                              <tr>
                                <td>{ele.id}
                                </td>
                                <td> <a
                                  href="javascript:void(0);"
                                  className="btn btn-xs btn-primary mb-1"
                                  data-bs-toggle="modal"
                                  data-bs-target="#sendMessageModal"
                                  onClick={() => setmodal_data(ele)}
                                >
                                  ✔
                                </a></td>

                                <td>
                                  <a
                                    target="_blank"
                                    className="text-primary"
                                    href={`${process.env.REACT_APP_EXPLORER}}#/transaction/${ele.hash}`}
                                    
                                    rel="noreferrer"
                                  >
                                    {formatAddress(ele.hash)}
                                  </a>
                                  {ele.hash ? <Copy data={ele.hash} /> : ""}
                                </td>
                                <td>
                                  <a
                                    target="_blank"
                                    className="text-primary"
                                    href={`${process.env.REACT_APP_EXPLORER}address/${ele.address}`}
                                    rel="noreferrer"
                                  >
                                    {formatAddress(ele.address)}
                                  </a>
                                  {ele.address ? (
                                    <Copy data={ele.address} />
                                  ) : (
                                    ""
                                  )}
                                </td>
                                <td> {ele.email}</td>
                                <td> {ele.user_id}</td>
                                <td> {ele.ref_id}</td>
                                <td>${ele.amount}</td>
                                <td>{ele.createdAt}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageSize={pageSize}
                      setPageSize={setPageSize}
                      pages={pages}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <div
        className="modal fade "
        id="sendMessageModal"
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Stake Pool Staking</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closemodal"
              />
            </div>
            <div className="modal-body">
              <form className="comment-form">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <div className="text-black  form-label">
                        Hash: {modal_data ? modal_data.hash : ''}
                      </div>
                      <div className="text-black  form-label">
                        Address: {modal_data ? modal_data.address : ''}
                      </div>
                      <div className="text-black  form-label">
                        User ID: {modal_data ? modal_data.user_id : 0}
                      </div>
                      <div className="text-black  form-label">
                        Amount: ${modal_data ? modal_data.amount : 0}
                      </div>
                      <div className="text-warning  form-label">
                        {modal_msg}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-3 mb-0">
                      <button
                        type="button"
                        className="submit btn btn-primary"
                        onClick={() => stake(modal_data ? modal_data.hash : null)}
                      >
                        Stake Now
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
